<template>
  <transition
    :css="animation.css"
    :name="animation.name"
    :mode="animation.mode"
    @enter="animation.enter"
    @leave="animation.leave"
    appear
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },
};
</script>

<style lang="scss" scoped>
@import './style/index';

.c-template.c-template--cookie {
  box-sizing: border-box;
  position: fixed;
  width: 310px;
  left: 50%;
  bottom: 60px;
  margin-left: -155px;
  padding: 20px 30px;

  font-size: 16px;
  font-family: $font-family-base;
  color: #B3B3B3;

  border: 0;
  border-radius: 5px;
  background-color: $color-white;

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;

  z-index: 100;

  span {
    font-family: $font-family-base;
  }
}
</style>
